var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopylink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13217_120240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83064 9.01692L9.00106 5.80159C9.22739 5.57234 9.22447 5.20309 8.99522 4.97676C8.76539 4.74984 8.39614 4.75334 8.17039 4.98259L4.99997 8.19792C4.77364 8.42717 4.77656 8.79642 5.00581 9.02276C5.11956 9.13476 5.26772 9.19076 5.41531 9.19076C5.56581 9.19076 5.71689 9.13242 5.83064 9.01692Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1064 1.83208C10.1901 -0.112168 7.91627 0.220915 4.95177 2.87858C4.71202 3.09383 4.69161 3.4625 4.90686 3.70225C5.12211 3.942 5.49019 3.96183 5.73052 3.74717C8.82044 0.975748 10.2216 1.58242 11.2757 2.65108C12.3362 3.72675 12.9394 5.15475 10.1954 8.29833C9.98361 8.541 10.0087 8.90967 10.2514 9.12142C10.3622 9.21825 10.4987 9.2655 10.6346 9.2655C10.7974 9.2655 10.9589 9.19783 11.0744 9.066C13.7257 6.028 14.0436 3.79675 12.1064 1.83208Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2681 10.2536C5.1776 13.0256 3.77702 12.4177 2.72293 11.3496C1.66243 10.2746 1.05927 8.84598 3.80327 5.70239C4.01502 5.45914 3.98993 5.09106 3.74727 4.87931C3.5046 4.66756 3.13652 4.69206 2.92418 4.93531C0.272935 7.97273 -0.0449818 10.2034 1.89285 12.1686C2.70777 12.9952 3.58685 13.41 4.55577 13.41C5.8671 13.41 7.34293 12.6505 9.04685 11.1221C9.2866 10.9069 9.30702 10.5382 9.09177 10.2985C8.87652 10.0581 8.50785 10.0383 8.2681 10.2536Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13217_120240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylink);
export default __webpack_public_path__ + "static/media/copylink.2b63ea7ae9d25b2c68e6a36a9ab663fd.svg";
export { ForwardRef as ReactComponent };